import { Spotlight } from '@atlaskit/onboarding';
import { token } from '@atlaskit/tokens';
import { useFirePostOfficeTrigger } from '@atlassian/post-office-context';
import { useCallback } from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from './messages';

export const DetailViewSpotlight = ({
	setNextStep,
	onDismissed,
	illustration,
}: {
	setNextStep: () => void;
	onDismissed: () => void;
	illustration: string;
}) => {
	const { formatMessage } = useIntl();
	const { fireTrigger } = useFirePostOfficeTrigger({
		triggerId: 'jira-nin-list-merge-modal-onboarding-explore-list-clicked',
	});

	const handleNext = useCallback(() => {
		setNextStep();
		fireTrigger({ isActive: true });
	}, [fireTrigger, setNextStep]);

	return (
		<Spotlight
			actions={[
				{
					onClick: handleNext,
					text: formatMessage(messages.exploreListViewButtonLabel),
				},
				{
					onClick: onDismissed,
					text: formatMessage(messages.listMergeSpotlightDismiss),
					appearance: 'subtle',
				},
			]}
			heading={formatMessage(messages.listMergeSpotlightHeading)}
			target="project-issue-navigator.ui.page-actions.view-switcher"
			key="project-issue-navigator.ui.page-actions.view-switcher"
			targetBgColor={token('elevation.surface')}
			targetRadius={3}
			dialogWidth={275}
			image={illustration}
			testId="list-merge-spotlight"
			dialogPlacement="left top"
		>
			{formatMessage(messages.listMergeSpotlightBody)}
		</Spotlight>
	);
};
